/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// tanstack query
import { useMutation } from '@tanstack/react-query';

// api
import { apiClient } from '@lib/api-client';

// types
import { TMutationConfig } from '@lib/react-query';
import { TProductionDTO } from '../types/dto';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type TUseMintProductionOptions = {
	mutationConfig?: TMutationConfig<
		typeof importProduction
	>;
};

type TImportProductionsInput = FormData;

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

export const importProduction = (
	data: TImportProductionsInput
): Promise<TProductionDTO> => {
	return apiClient.post(`/imports/productions`, data);
};

/* -------------------------------------------------------------------------- */
/*                                     Hooks                                  */
/* -------------------------------------------------------------------------- */
export const useImportProductions = ({
	mutationConfig,
}: TUseMintProductionOptions = {}) => {
	return useMutation({
		...mutationConfig,
		mutationFn: importProduction,
	});
};
